export const EXSBWAREHOUSETYPE_CREATE_RESET = 'EXSBWAREHOUSETYPE_CREATE_RESET'
export const EXSBWAREHOUSETYPE_CREATE_SET_CREATED = 'EXSBWAREHOUSETYPE_CREATE_SET_CREATED'
export const EXSBWAREHOUSETYPE_CREATE_SET_ERROR = 'EXSBWAREHOUSETYPE_CREATE_SET_ERROR'
export const EXSBWAREHOUSETYPE_CREATE_SET_VIOLATIONS = 'EXSBWAREHOUSETYPE_CREATE_SET_VIOLATIONS'
export const EXSBWAREHOUSETYPE_CREATE_TOGGLE_LOADING = 'EXSBWAREHOUSETYPE_CREATE_TOGGLE_LOADING'
